module.exports = __webpack_public_path__ + "media/images/vector-11@2x-5193e4f85cd299a4b05aefa1d25bdf9e.png";